import React from 'react'
import cloudimg from '../../assest/cloud-data.jpg';
import Aimodelimg from '../../assest/AI_Model.png';
import inputdataimg from '../../assest/InputData.png';
import outputimg from '../../assest/OutputPrediction.png';
import inputtitleimg from '../../assest/Input_Data_Titles.png';
import studentdata from '../../assest/StudentDataCluster.png';
import Aiworkflow from '../../assest/AI-workflow.png';
import './AiSolution.css'

const oldpage = () => {
  return (
    <>
       <div className='Ai-partition'>
          <div className='Ai-left'>
            <h3>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum illo labore unde,
              consequatur sequi pariatur vel quidem quod quae magni nostrum alias aliquam. Debitis,
              mollitia?
            </h3>
          </div>

          <div className='Ai-right'>
            <div className='Ai-box1' style={{ cursor: 'pointer' }}>
              <img src={cloudimg} alt="Download Data" />
              <p>Download Data Format</p>
            </div>

            <div className='Ai-box2'>
              <img src={cloudimg} alt="Sample Report" />
              <p>Download Sample Report</p>
            </div>

            <div className='Ai-box3'>
              <img src={cloudimg} alt="Upload Student Data" />
              <p>Upload Student's Data</p>
              <input
                type="file"
                accept=".xlsx, .xls"
                // onChange={handleFileUpload}
                // ref={fileInputRef} 
              />
            </div>
          </div>
        </div> 

         <div className='Ai-second-page'>
          <div className='Ai-image-container'>
            <img src={Aimodelimg} alt="AI Model" />
          </div>
          <img src={inputdataimg} alt="Input Data" />
          <img src={inputtitleimg} alt="Input Titles" />
          <img src={outputimg} alt="Output Prediction" />
          <img src={studentdata} alt="Student Cluster" />
          <img src={Aiworkflow} alt="Workflow" />
        </div>

       
    </>
  )
}

export default oldpage
